import StepGender from "components/Step/StepGender";
import { Subscription } from "lib/api/subscription";
import { shouldSkipReadingLevelStep } from "components/Membership/membershipUtil";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";

export const MembershipStepGender = ({
  prevSlug,
  routePrevStep,
  routeSkipPrevStep,
  ...state
}: MembershipState) => {
  const { childAge } = state;

  const backButtonProps = {
    onClick:
      prevSlug === "reading-level" && shouldSkipReadingLevelStep({ childAge })
        ? () => routeSkipPrevStep?.()
        : () => routePrevStep?.(),
  };

  return (
    <StepGender
      {...state}
      initialValues={state.genderValues}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_GENDER: MembershipStep = {
  component: MembershipStepGender,
  id: "membership-id-gender",
  slug: "gender",
};

export default MEMBERSHIP_STEP_GENDER;
